import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import {isDefined} from "~/lib/helpers/guards";

type EqualityFunction<T, U> = (row: T, value: U) => boolean;
type LabelFunction<T> = (a: T) => string;

const DEFAULT_EQ_FN: EqualityFunction<any, any> = (a, b) => a === b;
const DEFAULT_LABEL_FN: LabelFunction<any> = a => `${a}`;


@Component
export default class XSelect<T = any, U = any> extends Vue {

  @Prop({type: [Array], required: true}) data!: T[];
  @Prop({type: [Object, Number, String], required: false}) value!: U;
  @Prop({type: Function, required: false, default: DEFAULT_EQ_FN}) equality!: EqualityFunction<T, U>;
  @Prop({type: Function, required: false, default: DEFAULT_LABEL_FN}) label!: LabelFunction<T>;

  @Prop({type:Boolean, default:false}) allowNull:boolean;
  @Prop({type:Boolean, default:false}) readonly :boolean;
  @Prop({type:String, default:"---"}) nullLabel:string;

  onChange(e) {
    const { value: idx } = e.target;
    this.$emit("input", this.isNullValue(idx) ? null : this.data[idx]);
  }

  isRowSelected(r: T) {
    return this.equality(r, this.value);
  }

  isNullValue(x){
    if(typeof x === "string") return x.length === 0;
    return ! isDefined(x);
  }

  render() {
    return (
      <div class="select is-small">
        <select disabled={this.readonly} onChange={this.onChange}>
          {this.allowNull && <option value={null} selected={this.isNullValue(this.value)}>{this.nullLabel}</option>}
          {this.data.map((r: T, i) => (
            <option value={i} selected={this.isRowSelected(r)}>{this.label(r)}</option>
          ))}
        </select>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2818f37d/x-select.tsx" });